import { PolicyViolation } from '../../../../components/vulnerabilities-grid/shared'
import {
  GQLVulnerabilityOrSinkGroup,
  GQLSinkGroup
} from '../../types/vulnerability-sink-group'
import {
  GQLVulnerability,
  Session,
  GQLVulnerabilityApplication
} from '../../types/vulnerability'
import { GQLBugTracker } from '../../types/bug-trackers'

export function normalizeVulnerabilitySinkGroups(items: any[]) {
  return items.map((item) => normalizeVulnerabilitySinkGroup(item))
}

export function normalizeVulnerabilitySinkGroup(
  item: any
): GQLVulnerabilityOrSinkGroup {
  // eslint-disable-next-line unicorn/prefer-ternary
  if (item.vulnerability) {
    return {
      id: item.vulnerability.uuid,
      vulnerability: normalizeVulnerability(item.vulnerability),
      sinkGroup: null
    }
  } else {
    return {
      id: item.sinkGroup.sinkHash,
      sinkGroup: normalizeSinkGroup(item.sinkGroup),
      vulnerability: null
    }
  }
}

export function normalizeVulnerability({
  uuid: id,
  title,
  ruleName,
  visible,
  application,
  severity,
  defaultSeverity,
  tags,
  firstDetected,
  lastDetected,
  status,
  subStatus: substatus = null,
  bugTracker,
  violations,
  pendingStatus,
  sessionMetadata,
  protectStatus
}): GQLVulnerability {
  return {
    id,
    title,
    ruleName,
    visible,
    severity,
    defaultSeverity,
    tags,
    application: normalizeApplication(application),
    firstDetected,
    lastDetected,
    status,
    substatus,
    reportedToBugTracker: !!bugTracker,
    reportedToBugTrackerTime: bugTracker
      ? bugTracker.reportedToBugTrackerTime
      : null,
    bugTrackers: bugTracker
      ? normalizeBugTrackerTickets(bugTracker.bugTrackerTickets)
      : [],
    violations: normalizeRemediationPolicyViolations(violations),
    pendingStatus: normalizePendingStatus(pendingStatus),
    sessions: normalizeSessionMetadata(sessionMetadata),
    protectStatus
  }
}

function normalizeApplication({
  id,
  name,
  contextPath: url,
  importance,
  isLicensed: licensed,
  language,
  mostPermissiveRole: role,
  parentApplicationId,
  isParentApp
}): GQLVulnerabilityApplication {
  return {
    id,
    name,
    url,
    importance,
    licensed,
    language,
    role,
    parentApplicationId,
    isParentApp
  }
}

function normalizeBugTrackerTickets(tickets: any[]): GQLBugTracker[] {
  return tickets.map(
    ({
      bugTrackerName: name,
      bugTrackerType: type,
      creationTime: creation,
      ticketKey,
      ticketTitle,
      ticketUrl = null
    }) => {
      return {
        name,
        type,
        creation,
        ticketKey,
        ticketTitle,
        ticketUrl
      }
    }
  )
}

function normalizeRemediationPolicyViolations(
  violations: any[]
): PolicyViolation[] {
  return violations.map(({ policyId: id, name }) => ({
    id,
    name
  }))
}

function normalizePendingStatus(pendingStatus) {
  if (!!pendingStatus) {
    return {
      status: pendingStatus.status,
      created: pendingStatus.creationTime
    }
  }
  return null
}

export function normalizeSinkGroup(sinkGroup): GQLSinkGroup {
  const {
    application,
    count,
    firstDetected,
    lastDetected,
    ruleName,
    sessionMetadata,
    severity,
    sink,
    sinkHash,
    status,
    title,
    substatus = null,
    protectStatus
  } = sinkGroup

  return {
    application: application ? normalizeApplication(application) : null,
    count,
    firstDetected,
    lastDetected,
    ruleName,
    severity,
    sink,
    sinkHash,
    status,
    title,
    sessions: normalizeSessionMetadata(sessionMetadata),
    substatus,
    protectStatus
  }
}

function normalizeSessionMetadata(sessionMetadata): Session[] {
  return sessionMetadata.map(({ sessionId, metadata }) => {
    return {
      sessionID: sessionId,
      metadata
    }
  })
}
